import { jsx as _jsx } from "react/jsx-runtime";
import lodashGet from 'lodash/get';
import { formatNumber } from '../../../utility/formatNumber';
function CouplingColumn({ rowData, onHoverSignal, format, }) {
    const result = lodashGet(rowData, 'tableMetaInfo.signal.js');
    return (_jsx("td", { ...onHoverSignal, children: result
            ?.map((coupling) => !Number.isNaN(Number(coupling.coupling))
            ? formatNumber(coupling.coupling, format)
            : '')
            .join(',') }));
}
export default CouplingColumn;
